<template>
    <info-widget :collapsible="true" :is-expanded="expanded" @toggle_expand="expanded = !expanded">
        <template v-slot:title>Current Payroll Changes <span class="font-weight-normal">({{ totalCount }})</span></template>
        <slot>
            <div class="p-2">
                <div v-if="!locations.length" class="p-3 text-center text-muted">
                    No changes were made during this payroll run.
                </div>
                <div v-else>
                    <div class="p-1 pr-2">
                        <div v-for="location in locations" :key="location.work_location.id" class="pl-1">
                            <changes-report-location :location="location" :count="locationCount(location)" @open-employee="currentEmployee = $event" />
                        </div>
                    </div>
                </div>
            </div>
        </slot>

        <employee-sidebar
            v-if="currentEmployee"
            :client="client"
            :employee-id="currentEmployee"
            :key="currentEmployee"
            tab="payroll"
            @close="currentEmployee = null"
        />
    </info-widget>
</template>

<script>
import InfoWidget from '@/components/InfoWidget'
import EmployeeSidebar from '@/components/EmployeeSidebar'
import ChangesReportLocation from './ChangesReportLocation'

export default {
    components: {InfoWidget: InfoWidget, EmployeeSidebar: EmployeeSidebar, ChangesReportLocation: ChangesReportLocation},
    props: ['changesReport', 'client'],
    data() {
        return {
            expanded: true,
            currentEmployee: null,
        }
    },
    computed: {
        locations() {
            return (this.changesReport && this.changesReport.locations) || []
        },
        totalCount() {
            return this.locations.reduce((sum, location) => sum + this.locationCount(location), 0)
        },
    },
    methods: {
        locationCount(location) {
            const oneTime = location.one_time_changes
            const permanent = location.permanent_changes
            return (
                oneTime.separate_checks.length +
                oneTime.blocked_taxes.length +
                oneTime.blocked_deductions.length +
                permanent.rate_changes.length +
                permanent.positions_added.length +
                permanent.positions_removed.length +
                permanent.deduction_changes.length +
                permanent.deductions_added.length +
                permanent.deductions_removed.length
            )
        },
    },
}
</script>
